import type { IButtonStyles } from '@fluentui/react';
import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { createAppToggleButton, getKeytipString, constructKeytip } from 'owa-command-ribbon';
import type RibbonFormatState from 'owa-editor-ribbonplugin-store/lib/store/schema/RibbonFormatState';
import { callFormatApi } from 'owa-editor/lib/utils/callFormatApi';
import { getComposeRibbonId } from 'owa-compose-ribbon-utils/lib/utils/getComposeRibbonId';
import Bold from 'owa-fluent-icons-svg/lib/icons/TextBoldRegular';
import loc from 'owa-localize';
import { FormatControlId } from 'owa-ribbon-ids';
import { boldText } from './formatControlStrings.locstring.json';
import { isFeatureEnabled } from 'owa-feature-flags';

export const getBoldControl = computedFn(
    (
        editorId: string,
        formatViewState: RibbonFormatState,
        styles: IButtonStyles | undefined,
        tabId: number | undefined
    ): RibbonControlProps => {
        return createAppToggleButton(
            getComposeRibbonId(FormatControlId.Bold, editorId),
            loc(boldText),
            () => callFormatApi(editorId, 'toggleBold'),
            !!formatViewState.isBold,
            tabId && isFeatureEnabled('mon-ribbon-keytips')
                ? constructKeytip([getKeytipString(tabId)], getKeytipString(FormatControlId.Bold))
                : undefined,
            Bold,
            undefined /* iconColor */,
            styles
        );
    }
);
